import React from "react";
import styled from "styled-components";
import { FaDownload } from "react-icons/fa";

// Styled components
const DownloadButton = styled.button`
  padding: 10px;
  font-size: 16px;
  background-color: #3498db;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

export default function DownloadExcelFile() {
  const handleDownload = () => {
    // Path to the Excel file in the public folder
    const filePath = "./sample_excel_file.xlsx";

    // Create an anchor element
    const link = document.createElement("a");

    // Set the href attribute to the file path
    link.href = filePath;

    // Specify the download attribute with the desired file name
    link.download = "downloaded-file.xlsx";

    // Simulate a click to trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the anchor element
    document.body.removeChild(link);
  };

  return (
    <div style={{ lineHeight: "6", textAlign: "right" }}>
      <DownloadButton onClick={handleDownload}>
        <FaDownload style={{ marginRight: "5px" }} />
        Download Excel File
      </DownloadButton>
    </div>
  );
}
